import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContasReceberService {
  constructor() {
    this.urlBase = "/financeiro/contas-receber";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cadastrarLista(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/cadastro-lista`).post(
      body
    );
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  baixaEmLote(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  getResumoTotaisAReceber() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-receber-totais`
    ).get();
  }

  getResumoContasReceber() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-receber`
    ).get();
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/detalhado`
    ).patch(body);
  }

  cadastrarPagamentos(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/${id}/pagamentos`).post(
      body
    );
  }

  desdobrarTitulo(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/desdobrar-titulos`).post(
      body
    );
  }
}

export default ContasReceberService;
